import React, { useState, useEffect, useRef } from "react";
import {
  Volume2,
  VolumeOff
} from "lucide-react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import omsagapriceimg from "../assets/images/omsagapriceimg.webp";

import { Eye, Heart } from "lucide-react";
import { Link } from "react-router-dom";
import omimage from '../assets/images/omimage.png';
import storiesimg from '../assets/images/storiesimg.jpg';
import aboutimg from '../assets/images/omhome.png'
import trisulIcon from "../assets/images/trisul.png";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { apiUrl, assetsUrl } from "../config/Config";
import axios from "axios";
import Swal from 'sweetalert2';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
// import bannerImg from "../assets/images/new-home-page-img.png";
import bannerImg from "../assets/images/createstorynewbanner.png";
import useRazorpay from "react-razorpay";
import mobileimg1 from "../assets/images/mobilememimg1.webp";
import mobileimg2 from "../assets/images/mobilememimg2.webp";
import mobileimg3 from "../assets/images/mobilememimg3.webp";
import { Button, Modal } from "react-bootstrap";
import new_defaultimg from '../assets/images/new_omsaga_default.png';

const Home = () => {
  const customerdata = useSelector((store) => store.userReducer.customerdata);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openPopup, setOpenPopup] = useState(false);
  const [omopenPopup, setOmOpenPopup] = useState(false);
  const [allstories, setallstories] = useState([]);
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [contrilist, setcontrilist] = useState([]);
  const [contritotal, setcontritotal] = useState(0);
  const [contripercent, setcontripercent] = useState('0%');
  const [remainingtogoalamount, setremainingtogoalamount] = useState(0);

  const generateRandom22DigitNumber = (maxnum) => {
    let randomNumber = '';
    while (randomNumber.length < maxnum) {
      randomNumber += Math.floor(Math.random() * 10);
    }
    return randomNumber;
  }

  const paymentsuccessfunction = async (userid, amount, paymentResponse) => {
    const data = {
      userid: userid,
      paymentid: paymentResponse.razorpay_payment_id,
      orderid: paymentResponse.razorpay_order_id,
      signature: paymentResponse.razorpay_signature,
      purpose: "enrollment",
      amount: amount,
      contriamount: (amount / 2).toFixed(2)
    };

    try {
      const res = await axios.post(apiUrl + "updatepaymentstatus", data, {
        headers: { "Content-Type": "application/json" },
      });

      if (res?.data?.status == "success") {
        var prevdata = {};
        prevdata['email'] = customerdata?.email;
        prevdata['enroll'] = 'enroll';
        prevdata['fullname'] = customerdata?.fullname;
        prevdata['number'] = customerdata?.number;
        prevdata['token'] = customerdata?.token;
        prevdata['userid'] = customerdata?.userid;
        prevdata['payment_status'] = 'completed';
        dispatch({ type: "customerdata", payload: prevdata });
        navigate("/createstory");
      } else {
        alert(res.data.message || "Please Went wrong");
      }
    } catch (err) {
      console.error("API Error:", err);
      alert("Network or Server Error!");
    }
  }

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => { resolve(true); };
      script.onerror = () => { resolve(false); };
      document.body.appendChild(script);
    });
  };

  const displayrazorpay = async (amount) => {
    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js');

    if (!res) {
      alert('Razorpay SDK failed to load. Are you online?');
      return;
    }

    const options = {
      key: 'rzp_live_fhrJThrnFsQWLb',
      amount: amount * 100,
      currency: 'INR',
      name: 'OMSAGA',
      description: '',
      image: 'https://your-logo-url.com',
      handler: function (response) {
        console.log(response.razorpay_payment_id);
        paymentsuccessfunction(customerdata?.userid, amount, response);
      },
      notes: { address: 'Your Company Address' },
      theme: { color: '#fff' },
      modal: {
        ondismiss: function () { }
      }
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
    paymentObject.on('payment.failed', function (response) { });
    paymentObject.on('modal.close', function () { });
  }

  const loadRazorpay = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // console.log('customerdata >>', customerdata);

  const handleclickbtn = async() => {
    if (customerdata && Object.keys(customerdata)?.length > 0) {

      // displayrazorpay(1);
      // paymentsuccessfunction(1, "test001");
      // return;

      try {
        const { data } = await axios.post(apiUrl + "createrazorpayorder", {
          purpose: "enrollment",
        });

        const res = await loadRazorpay();

        if (!res) {
          alert("Razorpay SDK failed to load");
          return;
        }

        const options = {
          key: data.key,
          amount: data.amount * 100,
          currency: data.currency,
          name: "TheOmSaga",
          description: "",
          order_id: data.order_id,
          handler: function (response) {
            // alert("Payment Successful! Payment ID: " + response.razorpay_payment_id);
            paymentsuccessfunction(customerdata?.userid, data.amount, response);
            console.log(response);
          },
          prefill: {
            name: customerdata?.fullname,
            email: customerdata?.email,
            contact: "",
          },
          theme: {
            color: "#3399cc",
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();

      } catch (error) {
        console.error("Payment error:", error);
      } finally {
        // setLoading(false);
      }
    } else {
      navigate('/register');
    }
  }

  const handleplayaudio = (name) => {
    var url = '/storage/uploads/audio/' + name;

    if (!audioRef.current) {
      audioRef.current = new Audio(url);
    }

    audioRef.current.play();
    setPlaying(true);
  }

  const handleStop = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setPlaying(false);
    }
  };

  const formatDateDDMMYYYY = (dateTime) => {
    if (!dateTime) return "";

    const date = new Date(dateTime.replace(" ", "T"));
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const fetchallstories = async () => {
    const headers = { headers: { "Content-Type": "application/json" } };

    await axios.get(apiUrl + "gethomepagestories", headers)
      .then((res) => {
        if (res.data.status == "success") {
          var prevdata = res?.data?.data;

          if (prevdata?.length > 0) {
            setallstories(prevdata);
          } else {
            setallstories([]);
          }
        } else {
          setallstories([]);
        }
      }).catch((err) => {
        console.log('err >>', err);
      })
  }

  const fetchcontilist = async () => {
    const headers = { headers: { "Content-Type": "application/json" } };

    await axios.get(apiUrl + "getcurrentcyclecontributionlist", headers)
      .then((res) => {
        if (res.data.status == "success") {
          var prevdata = res?.data?.data;

          if (prevdata?.length > 0) {
            setcontrilist(prevdata);

            const total = prevdata.reduce(
              (sum, item) => sum + Number(item.contri_amount || 0),
              0
            );

            setcontritotal(total.toFixed(2));
            setremainingtogoalamount(20000 - total);

            const percent = (total.toFixed(2) / 20000) * 100;
            setcontripercent(percent.toFixed(2) + "%");
          } else {
            setcontrilist([]);
            setcontritotal(0);
            setremainingtogoalamount(0);
            setcontripercent('0%');
          }
        } else {
          // setallstories([]);
        }
      }).catch((err) => {
        console.log('err >>', err);
      })
  }

  const handlechecknavigate = () => {
    if (customerdata && Object.keys(customerdata)?.length > 0) {
      navigate("/allstory")
    } else {
      navigate("/register")
    }
  }

  useEffect(() => {
    fetchallstories();
    fetchcontilist();
  }, [])

  useEffect(() => {
    AOS.init({

    });
  }, []);

  return (
    <>
      <Helmet>

        {/* Meta Title */}
        <title>Best Spiritual Story Telling Platform | TheOmSaga</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Discover the best spiritual and inspirational spiritual tales. Read and share your real-life experiences of faith, miracles and devotion that uplift your soul."
        />

        {/* Primary Keywords */}
        <meta
          name="keywords"
          content="spiritual stories, spiritual story telling platform, inspirational spiritual stories"
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.theomsaga.com/" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Best Spiritual Story Telling Platform | TheOmSaga"
        />

        <meta
          property="og:description"
          content="Best spiritual story telling platform. Read and share your real-life experiences of faith, miracles and devotion that uplift your soul."
        />

        <meta property="og:url" content="https://theomsaga.com" />

        <meta
          property="og:image"
          content="https://theomsaga.com/assets/images/banner.webp"
        />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                "@id": "https://theomsaga.com/#organization",
                "name": "TheOmSaga",
                "url": "https://theomsaga.com/",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://theomsaga.com/assets/images/logo.webp"
                },
                "description": "TheOmSaga is a spiritual storytelling platform that shares real-life spiritual stories, faith experiences, and divine miracles to inspire and strengthen belief.",
                "sameAs": [
                  "https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw==",
                  "https://www.facebook.com/share/1B44vEtGc7/"
                ]
              },
              {
                "@type": "WebSite",
                "@id": "https://theomsaga.com/#website",
                "url": "https://theomsaga.com/",
                "name": "TheOmSaga",
                "description": "Read spiritual stories, inspirational spiritual stories, and real-life spiritual tales of faith, devotion, and miracles at TheOmSaga.",
                "publisher": {
                  "@id": "https://theomsaga.com/#organization"
                },
                "inLanguage": "en",
                "potentialAction": {
                  "@type": "SearchAction",
                  "target": "https://theomsaga.com/search?q={search_term_string}",
                  "query-input": "required name=search_term_string"
                }
              }
            ]
          }
          `}
        </script>
      </Helmet>

      <div>

        {/* FIRST SECTION - ONLY THIS SECTION IS VISIBLE */}
<section className="new-home-main-sec">
  <img
    src={bannerImg}
    className="new-home-main-sec-bg"
    alt="spiritual Banner"
  />

  <div className="new-home-main-sec-overlay"></div>

  <div className="container new-home-main-sec-content">

    {/* First Paragraph */}
    <p className="new-home-main-sec-subtitle">
     TheOmSaga is a spiritual, motivational, and community-driven platform built on the belief that one story can change many lives. It brings
      people of all ages together to write, read, share, and discover stories that inspire, motivate, and strengthen faith.
    </p>

    {/* Second Paragraph */}
    <p className="new-home-main-sec-subtitle">
      TheOmSaga spreads positivity, 
      promotes Sanatan culture, and connects generations through stories that inspire goodness and meaningful living.
    </p>

    {/* Button */}
    <div className="new-home-main-sec-btn-wrapper">
      <Link
        to="/register"
        className="new-home-main-sec-btn-link"
      >
        Join TheOmSaga to read/write stories
      </Link>
    </div>

  </div>
</section>

        {/* MIDDLE SECTION - HIDDEN */}
        <section
          className="home-page-mid-sec"
          style={{ display: "none" }}
        >
          <div className="container">

            <p className="home-page-mid-sec-heading">
              A Sacred Space for Spiritual Seekers
            </p>

            {/* <p className="home-page-mid-sec-para">
              This platform is meant for every generation, with a special focus
              on the youth. At a time when distractions often overshadow belief,
              TheOmSaga encourages the younger generation to embrace the power of
              prayer, understand the miracles of faith, and discover the peace
              that comes from trusting the divine. More than a collection of
              stories, TheOmSaga is a spiritual journey — one that unites hearts,
              strengthens belief, spreads positivity, and reaffirms the timeless
              truth that the supreme power is always with us.
            </p> */}

            <p className="home-page-mid-sec-para">
              Welcome to TheOmSaga — a sacred platform dedicated to spiritual
              stories, devotional experiences, and divine miracles rooted in the
              timeless wisdom of Sanatana Dharma. Here, faith comes alive through
              inspiring narratives that reflect the power of bhakti, prayer, and
              surrender, guiding seekers toward deeper devotion, spiritual growth,
              and inner peace. TheOmSaga connects believers with the divine presence
              that protects, transforms, and walks beside us in every phase of life.
            </p>

            <div className="home-page-mid-sec-wrapper">

              <div
                className="home-page-mid-sec-box"
                data-aos="fade-up"
                // data-aos-delay="100"
                data-aos-duration="300"
              >
                <span className="icon">🕉️</span>
                Spiritual stories passed down through families
              </div>

              <div
                className="home-page-mid-sec-box"
                data-aos="fade-up"
                // data-aos-delay="200"
                data-aos-duration="300"
              >
                <span className="icon">✨</span>
                Best spiritual short stories that are easy to read and deep in
                meaning
              </div>

              <div
                className="home-page-mid-sec-box"
                data-aos="fade-up"
                // data-aos-delay="300"
                data-aos-duration="300"
              >
                <span className="icon">🔥</span>
                Motivational spiritual stories that bring courage in difficult
                times
              </div>

              <div
                className="home-page-mid-sec-box"
                data-aos="fade-up"
                // data-aos-delay="400"
                data-aos-duration="300"
              >
                <span className="icon">🌸</span>
                Personal spiritual tales of prayer, devotion & divine help
              </div>

            </div>

            <div className="member-ship-sec-btn-wrapper">
              <button className="home-page-mid-sec-link">
                <Link
                  to="/stories"
                  className="member-ship-sec-btn-link"
                >
                  EXPLORE SPIRITUAL STORIES
                </Link>
              </button>
            </div>

          </div>
        </section>

        {/* 
        <section className="about-page-section">
          <div className="container">
            <div className="row align-items-center">

              <div className="col-12 col-md-6 col-lg-3 mb-4 ">
                <img src={aboutimg} alt="About" className="home-page-image" />
              </div>

              <div className="col-12 col-md-6 col-lg-9 mb-4 about-page-content">
                <h2 className="about-page-title">The Story Behind the Stories</h2>
                <p className="about-page-text">
                  TheOmSaga is a platform created to celebrate the richness of
                  Indian culture...
                </p>
              </div>

            </div>
          </div>
        </section> 
        */}

        {/* STORIES SECTION - HIDDEN */}
        {allstories?.length > 0 ? (
          <section
            className="home-stories-main-section"
            style={{ display: "none" }}
          >
            <div className="container text-center">

              <img
                src={omimage}
                className="om-image-stories"
              />

              <span className="home-subhead">
                Stories
              </span>

              <p className="home-heading">
                All Stories
              </p>

              <div className="home-heading-divider"></div>

              <Swiper
                spaceBetween={20}
                grabCursor={true}
                modules={[Autoplay]}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                loop={true}
                style={{ paddingBottom: "20px" }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                }}
              >

                {allstories?.map((item, index) => {

                  let reloadimg = "";

                  if (item?.photos) {
                    const arr = JSON.parse(item?.photos);

                    if (arr?.length > 0)
                      reloadimg = arr[0];
                  }

                  return (
                    <SwiperSlide
                      className="home-story-slide"
                      key={index}
                    >

                      <div className="home-story-card">

                        {/* BG Image */}
                        <img
                          src={
                            reloadimg
                              ? assetsUrl + "/photos/" + reloadimg
                              : new_defaultimg
                          }
                          className="home-story-card-img"
                          alt=""
                        />

                        {/* Dark bottom fade */}
                        <div className="home-story-overlay"></div>

                        {/* Category */}
                        <div className="home-story-category">
                          • Story
                        </div>

                        {/* Content */}
                        <div className="home-story-content">

                          <p className="home-story-title">
                            {item?.title}
                          </p>

                          <div className="home-meta-row">

                            <div className="home-meta-item">
                              <Heart size={14} />
                              <span>
                                {item?.liked || 0}
                              </span>
                            </div>

                            <div className="home-meta-item">
                              <Eye size={14} />
                              <span>
                                {item?.view || 0}
                              </span>
                            </div>

                          </div>

                          <p
                            className="home-story-readmore"
                            onClick={() =>
                              navigate("/story/" + item?.slug)
                            }
                          >
                            Read More
                          </p>

                        </div>

                        {/* Audio Icon */}
                        {item?.audio && (
                          <div className="home-story-audio">

                            {playing ? (
                              <VolumeOff
                                size={20}
                                onClick={() =>
                                  handleStop(item?.audio)
                                }
                              />
                            ) : (
                              <Volume2
                                size={20}
                                onClick={() =>
                                  handleplayaudio(item?.audio)
                                }
                              />
                            )}

                          </div>
                        )}

                      </div>

                    </SwiperSlide>
                  );
                })}

              </Swiper>

            </div>
          </section>
        ) : null}

        {/* 
        <section className="member-ship-sec">
          <div className="container">
            <h2 className="member-ship-sec-title">
              Your Contribution Creates a Divine Impact
            </h2>

            <div className="member-ship-sec-grid">

              <div className="member-ship-sec-box">
                <h3>50% - Divine Charity</h3>
                <p>
                  By contributing here, you also support the needy...
                </p>
              </div>

              <div className="member-ship-sec-trishul">
                <img src={trisulIcon} alt="Trishul"/>
              </div>

              <div className="member-ship-sec-box">
                <h3>One-Time Lifetime Registration ₹499</h3>
                <p>
                  This single modest contribution secures lifetime place.
                </p>
              </div>

              <div className="member-ship-sec-trishul">
                <img src={trisulIcon} alt="Trishul"/>
              </div>

              <div className="member-ship-sec-box">
                <h3>50% - TheOmSaga</h3>
                <p>
                  Supports platform operations and growth...
                </p>
              </div>

            </div>

            <div className="member-ship-sec-btn-wrapper">
              <button
                className="member-ship-sec-btn"
                onClick={() => handleclickbtn()}
              >
                <Link className="member-ship-sec-btn-link">
                  JOIN THEOMSAGA | REGISTER NOW FOR ₹499
                </Link>
              </button>
            </div>

          </div>
        </section> 
        */}

        {/* PRICE SECTION - HIDDEN */}
        <section
          className="home-page-omsaga-price-sec-desktop"
          style={{ display: "none" }}
        >

          <div className="container">

            <img
              src={omsagapriceimg}
              className="home-page-omsaga-price-sec"
            />

            <div className="home-page-omsaga-price-sec-container">

              <div className="home-page-omsaga-price-sec-box">

                {/* circle content already hai */}

                <p
                  className="home-page-omsaga-price-sec-btn home-page-omsaga-price-sec-btn1"
                  onClick={() => setOpenPopup(true)}
                >
                  Click Here
                </p>

              </div>

              <div className="home-page-omsaga-price-sec-box">

                <p
                  className="home-page-omsaga-price-sec-btn"
                  onClick={() => {
                    handlechecknavigate()
                  }}
                >
                  Click Here
                </p>

              </div>

              <div className="home-page-omsaga-price-sec-box">

                <p
                  className="home-page-omsaga-price-sec-btn home-page-omsaga-price-sec-btn3"
                  onClick={() => setOmOpenPopup("true")}
                >
                  Click Here
                </p>

              </div>

            </div>

          </div>

          {customerdata &&
          Object.keys(customerdata)?.length > 0 ? (

            customerdata?.enroll == "not enroll" ? (

              <div className="member-ship-sec-btn-wrapper">

                <button
                  className="member-ship-sec-btn"
                  onClick={() => handleclickbtn()}
                >
                  <Link className="member-ship-sec-btn-link">
                    JOIN THEOMSAGA | REGISTER NOW FOR ₹499
                  </Link>
                </button>

              </div>

            ) : (
              <>
                <br />
                <br />
                <br />
              </>
            )

          ) : (

            <div className="member-ship-sec-btn-wrapper">

              <button
                className="member-ship-sec-btn"
                onClick={() => handleclickbtn()}
              >
                <Link className="member-ship-sec-btn-link">
                  JOIN TheOmSaga | REGISTER NOW FOR ₹499
                </Link>
              </button>

            </div>

          )}

        </section>

        {/* 
        <div className="member-ship-sec-btn-wrapper">
          <button
            className="member-ship-sec-btn"
            onClick={() => handleclickbtn()}
          >
            <Link className="member-ship-sec-btn-link">
              JOIN TheOmSaga | REGISTER NOW FOR ₹499
            </Link>
          </button>
        </div> 
        */}

        {/* POPUP */}

        {/* 
        {openPopup && (
          <div className="home-page-omsaga-price-sec-popup">
            <div className="home-page-omsaga-price-sec-popup-content">

              <button
                className="home-page-omsaga-price-sec-popup-close"
                onClick={() => setOpenPopup(false)}
              >
                ×
              </button>

              <div className="home-page-omsaga-price-sec-donation-card">

                <h2 className="home-page-omsaga-price-sec-donation-title">
                  TheOmSaga
                </h2>

                {contrilist?.length > 0 ? (
                  <>
                    <table className="home-page-omsaga-price-sec-donation-table">

                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Date</th>
                          <th>Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {contrilist?.map((item, index) => {

                          return (
                            <tr>
                              <td>{item.fullname}</td>
                              <td>
                                {formatDateDDMMYYYY(item.created_at)}
                              </td>
                              <td>₹ {item.contri_amount}</td>
                            </tr>
                          );

                        })}
                      </tbody>

                    </table>

                    <p className="home-page-omsaga-price-sec-remaining">
                      Remaining to goal: ₹ {contritotal}
                    </p>
                  </>
                ) : null}

                <div className="home-page-omsaga-price-sec-progress">

                  <div
                    className="home-page-omsaga-price-sec-progress-fill"
                    style={{ width: contripercent }}
                  ></div>

                </div>

                <p className="home-page-omsaga-price-sec-note">
                  Once the total contribution reaches ₹20,000, the amount will
                  be donated to a charitable institute to help the needy.
                </p>

              </div>

            </div>
          </div>
        )} 
        */}

        <Modal
          show={openPopup}
          onHide={() => setOpenPopup(false)}
          size={"lg"}
          className="custom-width-modal"
        >

          <Modal.Body>

            <Modal.Header closeButton>

              <Modal.Title style={{ fontSize: 19 }}>
                THEOMSAGA
              </Modal.Title>

            </Modal.Header>

            <Modal.Body>

              <div className="webadmin-modalmainbody">

                {contrilist?.length > 0 ? (
                  <>

                    <table className="home-page-omsaga-price-sec-donation-table">

                      <thead>

                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Date</th>
                          <th>Amount</th>
                        </tr>

                      </thead>

                      <tbody>

                        {contrilist?.map((item, index) => {

                          return (
                            <tr>
                              <td>{item.username}</td>
                              <td className="blur-text">
                                {item.fullname}
                              </td>
                              <td>
                                {formatDateDDMMYYYY(item.created_at)}
                              </td>
                              <td>₹ {item.contri_amount}</td>
                            </tr>
                          );

                        })}

                      </tbody>

                    </table>

                    <p className="home-page-omsaga-price-sec-remaining">
                      Contributed amount so far : ₹ {contritotal}
                    </p>

                  </>
                ) : null}

                <div className="home-page-omsaga-price-sec-progress">

                  <div
                    className="home-page-omsaga-price-sec-progress-fill"
                    style={{ width: contripercent }}
                  ></div>

                </div>

                {/* 
                <p className="home-page-omsaga-price-sec-note">
                  Once the total contribution reaches <strong>₹20,000,</strong>
                  the amount will be donated to a charitable institute to help
                  the needy.
                </p> 
                */}

              </div>

            </Modal.Body>

          </Modal.Body>

        </Modal>

        <Modal
          show={omopenPopup}
          onHide={() => setOmOpenPopup(false)}
          size={"lg"}
          className="custom-width-modal"
        >

          <Modal.Body>

            <Modal.Header closeButton>

              <Modal.Title style={{ fontSize: 19 }}>
                THEOMSAGA
              </Modal.Title>

            </Modal.Header>

            <Modal.Body>

              <div className="webadmin-modalmainbody">

                {contrilist?.length > 0 ? (
                  <>

                    <table className="home-page-omsaga-price-sec-donation-table">

                      <thead>

                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Date</th>
                          <th>Amount</th>
                        </tr>

                      </thead>

                      <tbody>

                        {contrilist?.map((item, index) => {

                          return (
                            <tr>
                              <td>{item.username}</td>

                              <td className="blur-text">
                                {item.fullname}
                              </td>

                              <td>
                                {formatDateDDMMYYYY(item.created_at)}
                              </td>

                              <td>
                                ₹ {parseFloat(
                                  parseFloat(item.amount) -
                                  parseFloat(item.contri_amount)
                                ).toFixed(2)}
                              </td>
                            </tr>
                          );

                        })}

                      </tbody>

                    </table>

                    {/* 
                    <p className="home-page-omsaga-price-sec-remaining">
                      Contributed amount so far : ₹ {contritotal}
                    </p> 
                    */}

                  </>
                ) : null}

                {/* 
                <div className="home-page-omsaga-price-sec-progress">

                  <div
                    className="home-page-omsaga-price-sec-progress-fill"
                    style={{ width: contripercent }}
                  ></div>

                </div> 
                */}

                <p className="home-page-omsaga-price-sec-note">
                  The amount will be allocated toward the website’s operational
                  expenses and marketing activities.
                </p>

              </div>

            </Modal.Body>

          </Modal.Body>

        </Modal>

        {/* 
        {omopenPopup && (
          <div className="home-page-omsaga-price-sec-popup">

            <div className="home-page-omsaga-price-sec-popup-content">

              <button
                className="home-page-omsaga-price-sec-popup-close"
                onClick={() => setOmOpenPopup(false)}
              >
                ×
              </button>

              <div className="home-page-omsaga-price-sec-donation-card">

                <h2 className="home-page-omsaga-price-sec-donation-title">
                  TheOmSaga
                </h2>

                <table className="home-page-omsaga-price-sec-donation-table">

                  <thead>

                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Date</th>
                      <th>Amount</th>
                    </tr>

                  </thead>

                  <tbody>

                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                  </tbody>

                </table>

                <p className="home-page-omsaga-price-sec-remaining">
                  Contributed amount so far : ₹
                </p>

                <div className="home-page-omsaga-price-sec-progress">

                  <div
                    className="home-page-omsaga-price-sec-progress-fill"
                    style={{ width: contripercent }}
                  ></div>

                </div>

                <p className="home-page-omsaga-price-sec-note">
                  The amount will be allocated toward the website’s operational
                  expenses and marketing activities.
                </p>

              </div>

            </div>

          </div>
        )} 
        */}

        {/* 
        <section className="mobile-view-sec">

          <div className="container">

            <div className="row home-join-member-section">

              <div className="col-md-4 home-join-member-section-col">

                <img
                  className="home-join-member-img"
                  src={mobileimg1}
                />

                <p
                  className="home-page-omsaga-price-sec-btn"
                  onClick={() => setOpenPopup(true)}
                >
                  Click Here
                </p>

              </div>

              <div className="col-md-4">

                <img
                  className="home-join-member-img"
                  src={mobileimg2}
                />

                <p
                  className="home-page-omsaga-price-sec-btn"
                  onClick={() => {
                    handlechecknavigate()
                  }}
                >
                  Click Here
                </p>

              </div>

              <div className="col-md-4">

                <img
                  className="home-join-member-img"
                  src={mobileimg3}
                />

                <p
                  className="home-page-omsaga-price-sec-btn home-page-omsaga-price-sec-btn3"
                  onClick={() => setOmOpenPopup("true")}
                >
                  Click Here
                </p>

              </div>

            </div>

            {customerdata &&
            Object.keys(customerdata)?.length > 0 ? (

              customerdata?.enroll == "not enroll" ? (

                <div className="member-ship-sec-btn-wrapper">

                  <button
                    className="member-ship-sec-btn"
                    onClick={() => handleclickbtn()}
                  >
                    <Link className="member-ship-sec-btn-link">
                      JOIN THEOMSAGA | REGISTER NOW FOR ₹499
                    </Link>
                  </button>

                </div>

              ) : (
                <>
                  <br />
                  <br />
                  <br />
                </>
              )

            ) : (

              <div className="member-ship-sec-btn-wrapper">

                <button
                  className="member-ship-sec-btn"
                  onClick={() => handleclickbtn()}
                >
                  <Link className="member-ship-sec-btn-link">
                    JOIN THEOMSAGA | REGISTER NOW FOR ₹499
                  </Link>
                </button>

              </div>

            )}

          </div>

        </section> 
        */}

      </div>
    </>
  );
}

export default Home;
